export default __webpack_public_path__ + "static/media/logo-white.3c8e72a7.svg";